import { useLocation } from "react-router-dom";

import { stringOrUndefined } from "@faire/retailer/lib/stringOrUndefined";

export const useProductTokenForUpdateCartModal = (): string | undefined => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const product = searchParams.get("product");
  return stringOrUndefined(product);
};
